import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    bottomGap: { type: Number, default: 24 }
  }

  connect() {
    this.updateHeight = this.updateHeight.bind(this)
    window.addEventListener("resize", this.updateHeight)
    document.addEventListener("turbo:frame-load", this.updateHeight)
    document.addEventListener("turbo:render", this.updateHeight)
    this.updateHeight()
  }

  disconnect() {
    window.removeEventListener("resize", this.updateHeight)
    document.removeEventListener("turbo:frame-load", this.updateHeight)
    document.removeEventListener("turbo:render", this.updateHeight)
  }

  updateHeight() {
    requestAnimationFrame(() => {
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight
      const rect = this.element.getBoundingClientRect()
      const availableHeight = viewportHeight - rect.top - this.bottomGapValue

      if (availableHeight <= 320) {
        return
      }

      this.element.style.minHeight = `${availableHeight}px`
      this.element.style.height = `${availableHeight}px`
      this.element.style.maxHeight = `${availableHeight}px`
    })
  }
}


